<!-- 质保信息 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Menu
                mode="horizontal"
                :active-name="name_id"
                @on-select="selectName"
            >
                <MenuItem name="1">页面设置</MenuItem>
                <MenuItem name="2">边距设置</MenuItem>
            </Menu>
            <div class="mt24 mb24">
                <div v-if="name_id == 1">
                    <div class="menu-div">
                        <div
                            :class="
                                newFormData.content.menu_value == 1
                                    ? 'menuitem-div-active'
                                    : 'menuitem-div'
                            "
                            @click="changeMenu(1)"
                        >
                            未激活
                        </div>
                        <div
                            :class="
                                newFormData.content.menu_value == 2
                                    ? 'menuitem-div-active'
                                    : 'menuitem-div'
                            "
                            @click="changeMenu(2)"
                        >
                            信息填写
                        </div>
                        <div
                            :class="
                                newFormData.content.menu_value == 3
                                    ? 'menuitem-div-active'
                                    : 'menuitem-div'
                            "
                            @click="changeMenu(3)"
                        >
                            已激活
                        </div>
                    </div>
                    <Form
                        :model="newFormData"
                        label-position="left"
                        :label-width="90"
                    >
                        <div class="form-title">质保信息</div>
                        <FormItem label="标题样式">
                            <RadioGroup
                                v-model="newFormData.content.style_value"
                            >
                                <Radio class="mr24" label="1">样式一</Radio>
                                <Radio class="mr24" label="2">样式二</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.style_value == 2"
                            label="标题位置"
                        >
                            <RadioGroup
                                v-model="newFormData.content.position"
                                type="button"
                            >
                                <Radio label="left"
                                    ><Icon type="md-menu"
                                /></Radio>
                                <Radio label="center"
                                    ><Icon type="md-funnel"
                                /></Radio>
                                <Radio label="right"
                                    ><Icon type="md-menu"
                                /></Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="标题文字">
                            <Input
                                v-model="newFormData.content.title"
                                placeholder="请输入标题文字"
                            ></Input>
                        </FormItem>
                        <FormItem label="文字大小">
                            <Input
                                v-model="newFormData.content.title_size"
                                placeholder="请输入文字大小"
                                ><span slot="append">PX</span></Input
                            >
                        </FormItem>
                        <FormItem label="标题颜色">
                            <ColorPicker
                                v-model="newFormData.content.title_color"
                            />
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.style_value == 1"
                            label="装饰颜色"
                        >
                            <ColorPicker
                                v-model="newFormData.content.dec_color"
                            />
                        </FormItem>
                        <FormItem label="分割线颜色">
                            <ColorPicker
                                v-model="newFormData.content.dividingline_color"
                            />
                        </FormItem>
                        <FormItem label="标题背景">
                            <ColorPicker
                                v-model="newFormData.content.title_bg_color"
                            />
                        </FormItem>
                        <template v-if="newFormData.content.menu_value == 1">
                            <div class="form-title">内容设置</div>
                            <FormItem label="提示文字">
                                <Input
                                    v-model="newFormData.content.text1"
                                    type="textarea"
                                    placeholder="请输入提示文字"
                                ></Input>
                            </FormItem>
                            <FormItem label="文字大小">
                                <Input
                                    v-model="newFormData.content.text_size1"
                                    placeholder="请输入文字大小"
                                    ><span slot="append">PX</span></Input
                                >
                            </FormItem>
                            <FormItem label="文字颜色">
                                <ColorPicker
                                    v-model="newFormData.content.text_color1"
                                />
                            </FormItem>
                            <div class="form-title">按钮设置</div>
                            <FormItem label="按钮文字">
                                <Input
                                    v-model="newFormData.content.btn_text"
                                    placeholder="请输入按钮文字"
                                ></Input>
                            </FormItem>
                            <FormItem label="文字颜色">
                                <ColorPicker
                                    v-model="newFormData.content.btn_text_color"
                                />
                            </FormItem>
                            <FormItem label="按钮边框">
                                <ColorPicker
                                    v-model="
                                        newFormData.content.btn_border_color
                                    "
                                />
                            </FormItem>
                            <FormItem label="按钮颜色">
                                <ColorPicker
                                    v-model="newFormData.content.btn_color"
                                />
                            </FormItem>
                        </template>
                        <template v-if="newFormData.content.menu_value == 2">
                            <div class="form-title">添加字段</div>
                            <div class="flex-sb">
                                <Select
                                    class="mr24 w200"
                                    v-model="field_value"
                                    clearable
                                    filterable
                                    placeholder="请选择"
                                >
                                    <Option
                                        v-for="item in fieldList"
                                        :value="item.id"
                                        :key="item.id"
                                        >{{ item.name }}</Option
                                    >
                                </Select>
                                <Button
                                    class="theme-bc theme-default-color"
                                    @click="addTable"
                                    >添加字段</Button
                                >
                            </div>
                            <div class="table-container">
                                <Table
                                    :columns="columnsTable"
                                    :data="dataTable"
                                    border
                                    draggable
                                    @on-drag-drop="handleDragDrop"
                                >
                                    <template
                                        slot-scope="{ row, index }"
                                        slot="operate"
                                    >
                                        <div class="flex-sa">
                                            <div
                                                class="table-edit"
                                                @click="tableEdit(row, index)"
                                            >
                                                编辑
                                            </div>
                                            <div
                                                v-if="row.default != 1"
                                                class="table-del"
                                                @click="tableDel(index)"
                                            >
                                                删除
                                            </div>
                                        </div>
                                    </template>
                                </Table>
                            </div>
                            <div class="form-title">样式设置</div>
                            <FormItem label="标题大小">
                                <Input
                                    v-model="newFormData.content.title_size2"
                                    placeholder="请输入标题大小"
                                    ><span slot="append">PX</span></Input
                                >
                            </FormItem>
                            <FormItem label="标题颜色">
                                <ColorPicker
                                    v-model="newFormData.content.title_color2"
                                />
                            </FormItem>
                            <!-- <div class="form-title">提示/输入文字</div>
                            <FormItem label="提示文本">
                                <ColorPicker
                                    v-model="
                                        newFormData.content.prompt_text_color2
                                    "
                                />
                            </FormItem>
                            <FormItem label="输入文本">
                                <ColorPicker
                                    v-model="newFormData.content.text_color2"
                                />
                            </FormItem> -->
                            <div class="form-title">按钮设置</div>
                            <FormItem label="按钮文字">
                                <Input
                                    v-model="newFormData.content.btn_text2"
                                    placeholder="请输入按钮文字"
                                ></Input>
                            </FormItem>
                            <FormItem label="文字颜色">
                                <ColorPicker
                                    v-model="
                                        newFormData.content.btn_text_color2
                                    "
                                />
                            </FormItem>
                            <FormItem label="按钮边框">
                                <ColorPicker
                                    v-model="
                                        newFormData.content.btn_border_color2
                                    "
                                />
                            </FormItem>
                            <FormItem label="按钮颜色">
                                <ColorPicker
                                    v-model="newFormData.content.btn_color2"
                                />
                            </FormItem>
                        </template>
                        <template v-if="newFormData.content.menu_value == 3">
                            <div class="form-title">样式设置</div>
                            <FormItem label="文字大小">
                                <Input
                                    v-model="newFormData.content.form_txt_size3"
                                    placeholder="请输入文字大小"
                                    ><span slot="append">PX</span></Input
                                >
                            </FormItem>
                            <FormItem label="标题颜色">
                                <ColorPicker
                                    v-model="
                                        newFormData.content.form_title_color3
                                    "
                                />
                            </FormItem>
                            <FormItem label="内容颜色">
                                <ColorPicker
                                    v-model="
                                        newFormData.content.form_text_color3
                                    "
                                />
                            </FormItem>
                            <FormItem label="进度条颜色">
                                <ColorPicker
                                    v-model="newFormData.content.bar_color"
                                />
                            </FormItem>
                            <div class="form-title">自定义信息</div>
                            <FormItem label="质保信息">
                                <editor
                                    :edtor-con="newFormData.content.text3"
                                    :index="1"
                                    @getContent="getEnContent"
                                    @getContentchange="getEnContentchange"
                                    :dis-upload="1"
                                />
                            </FormItem>
                            <div class="tip-container">
                                提示： {#active}代表激活日期，
                                {#surplus}代表剩余天数， {#start}代表开始时间，
                                {#end}代表结束时间
                            </div>
                        </template>
                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色">
                            <ColorPicker
                                v-model="newFormData.content.bg_color"
                            />
                        </FormItem>
                        <FormItem label="背景图">
                            <i-switch
                                v-model="newFormData.content.bg_value"
                                size="large"
                                true-color="#FF761D "
                                :true-value="1"
                                :false-value="0"
                                @on-change="changeBgValue"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.bg_value"
                            label="上传背景"
                        >
                            <div class="bg-upload" @click="openModal('bg_img')">
                                <img
                                    class="bg-img"
                                    v-if="newFormData.content.bg_img.picview"
                                    :src="newFormData.content.bg_img.picview"
                                />
                                <Icon
                                    v-else
                                    type="md-add"
                                    size="30"
                                    color="#ccc"
                                />
                            </div>
                        </FormItem>
                    </Form>
                </div>
            </div>
            <div v-if="name_id == 2">
                <Form
                    :model="newFormData"
                    label-position="right"
                    :label-width="80"
                >
                    <div class="form-title">外间距</div>
                    <FormItem label="上下间距"
                        ><Slider
                            v-if="newFormData.content.marginData"
                            class="w300"
                            show-input
                            v-model="newFormData.content.marginData.top"
                        ></Slider
                    ></FormItem>
                    <FormItem label="左右间距"
                        ><Slider
                            v-if="newFormData.content.marginData"
                            class="w300"
                            show-input
                            v-model="newFormData.content.marginData.left"
                        ></Slider
                    ></FormItem>
                    <div class="form-title">内间距</div>
                    <FormItem label="上下间距"
                        ><Slider
                            v-if="newFormData.content.paddingData"
                            class="w300"
                            show-input
                            v-model="newFormData.content.paddingData.top"
                        ></Slider
                    ></FormItem>
                    <FormItem label="左右间距"
                        ><Slider
                            v-if="newFormData.content.paddingData"
                            class="w300"
                            show-input
                            v-model="newFormData.content.paddingData.left"
                        ></Slider
                    ></FormItem>
                    <div class="form-title">圆角设置</div>
                    <FormItem label="上圆角"
                        ><Slider
                            v-if="newFormData.content.radiusData"
                            class="w300"
                            show-input
                            v-model="newFormData.content.radiusData.top"
                        ></Slider
                    ></FormItem>
                    <FormItem label="下圆角"
                        ><Slider
                            v-if="newFormData.content.radiusData"
                            class="w300"
                            show-input
                            v-model="newFormData.content.radiusData.bottom"
                        ></Slider
                    ></FormItem>
                </Form>
            </div>
        </div>
        <!-- 字段编辑 -->
        <Modal
            v-model="field_modal"
            title="字段编辑"
            width="500"
            :mask-closable="false"
        >
            <Form :model="field_data" label-position="right" :label-width="100">
                <div class="form-title">预设类型</div>
                <template v-if="field_data.default == 1">
                    <FormItem label="是否显示">
                        <RadioGroup
                            v-model="field_data.display_value"
                            @on-change="changeDisplay"
                        >
                            <Radio class="mr24" label="1">显示</Radio>
                            <Radio class="mr24" label="2">不显示</Radio>
                        </RadioGroup>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="tooltip-icon"
                                type="md-help-circle"
                                size="20"
                                color="#FF761D"
                            />
                            <div slot="content"><p>信息填写时是否显示</p></div>
                        </Tooltip>
                    </FormItem>
                    <template v-if="field_data.display_value == 1">
                        <FormItem label="字段属性">
                            <RadioGroup v-model="field_data.required_value">
                                <Radio class="mr24" label="1">必填</Radio>
                                <Radio class="mr24" label="2">不必填</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="是否隐藏">
                            <RadioGroup v-model="field_data.hide_value">
                                <Radio class="mr24" label="1">隐藏</Radio>
                                <Radio class="mr24" label="2">不隐藏</Radio>
                            </RadioGroup>
                            <Tooltip
                                max-width="250"
                                placement="right"
                                theme="light"
                            >
                                <Icon
                                    class="tooltip-icon"
                                    type="md-help-circle"
                                    size="20"
                                    color="#FF761D"
                                />
                                <div slot="content">
                                    <p>已激活后是否显示</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </template>
                </template>
                <FormItem v-else label="字段属性">
                    <RadioGroup v-model="field_data.required_value">
                        <Radio class="mr24" label="1">必填</Radio>
                        <Radio class="mr24" label="2">不必填</Radio>
                    </RadioGroup>
                </FormItem>
                <template v-if="field_data.phone_value != 1">
                    <div class="form-title">标题设置</div>
                    <FormItem label="内容标题">
                        <Input
                            type="text"
                            v-model="field_data.title_name"
                            placeholder="请输入内容标题"
                        ></Input>
                    </FormItem>
                    <FormItem
                        v-if="
                            field_data.type == 1 ||
                            field_data.type == 3 ||
                            field_data.type == 5 ||
                            field_data.type == 6
                        "
                        label="提示文字"
                    >
                        <Input
                            type="text"
                            v-model="field_data.prompt_text"
                            placeholder="请输入提示文字"
                        ></Input>
                    </FormItem>
                </template>
                <div
                    v-if="
                        field_data.type == 2 ||
                        field_data.type == 4 ||
                        field_data.type == 5
                    "
                    class="form-title"
                >
                    内容设置
                </div>
                <FormItem
                    v-if="
                        field_data.type == 2 ||
                        field_data.type == 4 ||
                        field_data.type == 5
                    "
                    label="字段类型值"
                >
                    <Input
                        type="textarea"
                        v-model="field_data.type_val"
                        placeholder="多个选项用*分割"
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelFieldModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitFieldModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
import editor from "@/components/editor/editor.vue";
export default {
    components: { pictureLibrary, editor },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
            fieldList: [
                { id: 1, name: "单行文本" },
                { id: 2, name: "多选" },
                { id: 3, name: "多行文本" },
                { id: 4, name: "单选" },
                { id: 5, name: "下拉框" },
                { id: 6, name: "选择日期" },
                { id: 7, name: "图片" },
                { id: 8, name: "视频" },
            ],
            field_value: 1,
            field_modal: false,
            field_data: {
                title_name: "",
                type: "",
                type_name: "",
                prompt_text: "",
                required_value: "",
                default: 0,
                type_val: "",
                type_active: null,
                input_value: null,
                show_upload: null,
                upload_value: null,
            },
            field_active_value: "",
            columnsTable: [
                { title: "标题名称", key: "title_name", align: "center" },
                { title: "字段类型", key: "type_name", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "150px",
                },
            ],
            dataTable: [],
        };
    },
    mounted() {
        this.dataTable = [...this.newFormData.content.tableList];
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.bg_img.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.bg_img.value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal() {
            this.switch_modal = true;
        },
        selectName(name) {
            this.name_id = name;
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
        changeMenu(i) {
            this.newFormData.content.menu_value = i;
        },
        addTable() {
            var type_name;
            if (this.field_value == 2) {
                type_name = "多选";
            } else if (this.field_value == 3) {
                type_name = "多行文本";
            } else if (this.field_value == 4) {
                type_name = "单选";
            } else if (this.field_value == 5) {
                type_name = "下拉框";
            } else if (this.field_value == 6) {
                type_name = "选择日期";
            } else if (this.field_value == 7) {
                type_name = "图片";
            } else if (this.field_value == 8) {
                type_name = "视频";
            } else {
                type_name = "单行文本";
            }
            this.newFormData.content.tableList.push({
                title_name: "",
                type: this.field_value,
                type_name: type_name,
                prompt_text: "",
                required_value: "1",
                default: 0,
                type_val: "",
                type_active: this.field_value == 2 ? [] : null,
                input_value: null,
                show_upload: null,
                upload_value: null,
            });
            this.dataTable = [...this.newFormData.content.tableList];
        },
        tableEdit(item, index) {
            this.field_active_value = index;
            this.field_data = JSON.parse(JSON.stringify(item));
            this.field_modal = true;
        },
        tableDel(index) {
            this.newFormData.content.tableList.splice(index, 1);
            this.dataTable = [...this.newFormData.content.tableList];
        },
        cancelFieldModal() {
            this.field_modal = false;
        },
        submitFieldModal() {
            this.newFormData.content.tableList[this.field_active_value] = {
                ...this.field_data,
            };
            this.dataTable = [...this.newFormData.content.tableList];
            this.field_modal = false;
        },
        changeDisplay(e) {
            if (e == 2) {
                this.field_data.required_value = "2";
                this.field_data.hide_value = "1";
            }
        },
        //富文本
        getEnContentchange(detailData) {
            this.newFormData.content.text3 = detailData.editorData;
        },
        getEnContent(detailData) {
            this.newFormData.content.text3 = detailData.editorData;
        },
        handleDragDrop(index, fromIndex) {
            console.log(`从 ${index} 拖拽到 ${fromIndex}`);
            // const data = this.dataTable
            // const item = data.splice(index, 1)[0]
            // data.splice(fromIndex, 0, item)
            // this.dataTable = [...data]
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
.menu-div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(255, 118, 29, 0.1);
    border-radius: 6px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #747b95;
    padding: 3px 6px;
    cursor: pointer;
}
.menuitem-div-active {
    flex: 1;
    text-align: center;
    background: #ff761d;
    border-radius: 6px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    padding: 6px 24px;
}
.menuitem-div {
    flex: 1;
    text-align: center;
}
.flex-sb {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.table-container {
    margin-top: 12px;
}
.table-edit {
    color: #ff761d;
    cursor: pointer;
}
.table-del {
    color: #ff0000;
    cursor: pointer;
}
.tooltip-icon {
    margin-left: 10px;
    cursor: pointer;
}
.tip-container {
    margin-left: 90px;
    font-size: 12px;
    color: #999;
}
/* RadioGroup */
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #fff;
    border-color: #ff761d;
    color: #ff761d;
    box-shadow: -1px 0 0 0 #ff761d;
}
::v-deep .ivu-radio-group-button :hover {
    color: #ff761d;
}
::v-deep .ivu-radio-checked .ivu-radio-inner {
    border-color: #ff761d;
}
::v-deep .ivu-radio-inner:after {
    background-color: #ff761d;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
</style>